import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { NCCardSectionHeader, printLatestDate } from '@/components/NCCard/NCCard';
import { getNCChangeIcon, getNCChangeIconVariant, NCFactCapsule } from '@/components/NCFactCapsule/NCFactCapsule';

export const CanopyCoverCardStatsTile = ({
  latestAnalysisFact,
}: {
  latestAnalysisFact: PlotReportFactElement<number | null> | undefined;
}) => {
  const { t } = useTranslation();

  const latestAnalysisDate = printLatestDate([latestAnalysisFact?.measured_at]);

  return (
    <div className='flex flex-col gap-8 lg:gap-4 pt-8' data-testid='canopy-cover-stats-tile'>
      <NCCardSectionHeader
        title={t('shared.ncaDetail.details.forest.labels.averageCanopyCover')}
        supplementaryInfo={`${t('shared.ncaDetail.details.labels.updated')} ${latestAnalysisDate}`}
        popover={{
          title: t('shared.ncaDetail.details.forest.explainers.averageCanopyCover.title'),
          body: t('shared.ncaDetail.details.forest.explainers.averageCanopyCover.body'),
        }}
      />
      <Stack direction='row' className='flex-wrap gap-16'>
        <NCFactCapsule
          label={t('shared.ncaDetail.details.labels.latestAnalysis')}
          fact={latestAnalysisFact}
          capsuleIconProps={{
            icon: getNCChangeIcon(latestAnalysisFact),
            variant: getNCChangeIconVariant(latestAnalysisFact),
          }}
          infoPopoverProps={{
            title: t('shared.ncaDetail.details.explainers.latestAnalysis.title'),
            body: t('shared.ncaDetail.details.explainers.latestAnalysis.body', {
              date: latestAnalysisDate,
            }),
            popoverTriggerProps: {
              'data-testid': 'average-canopy-cover-latest-analysis-popover',
            },
          }}
        />
      </Stack>

      <Stack className='mt-4 gap-4 rounded-2xl bg-neutral-black-4 px-4 py-6'>
        <span className='typography-body1Bold'>
          {t('shared.ncaDetail.details.forest.explainers.canopyCoverDetails.title')}
        </span>
        <p className='typography-body1 text-text-secondary'>
          {t('shared.ncaDetail.details.forest.explainers.canopyCoverDetails.body')}
        </p>
      </Stack>
    </div>
  );
};
